package editor

import rendering.EffectManager
import three.js.Intersection
import three.js.Object3D

/**
 * Manage the highlighting of the selected object.
 */
object SelectionManager {
    /**
     * Maybe update the selection based on the intersection. Any object in the [from] array
     * may be selected.
     *
     * @return the newly selected object
     */
    // todo alternative to flatMap?
    fun maybeSelect(from: Array<Object3D>, intersection: Intersection?): Object3D? {
        val newSelected = from.flatMap {
            it.children.toList()
        }.firstOrNull {
            it.uuid == intersection?.`object`?.parent?.uuid
                    // check parent's parent for hovering over non-wooden part of wheels object!
                    || it.uuid == intersection?.`object`?.parent?.parent?.uuid
        }

        if (newSelected != null) {
            EffectManager.select(arrayOf(newSelected))
        } else {
            EffectManager.select(emptyArray())
        }

        return newSelected
    }

    /**
     * Select all the outlines for rendering. This uses the children's children so that the individual spheres of the
     * brixi are outlined individually. Only used for capturing in Drawing/Outlines mode.
     */
    fun selectOutlinesForRender() {
        EffectManager.select(EditorManager.getStructure().flatMap { it.object3D.children.flatMap { child -> child.children.asList() } }.toTypedArray())
    }
}